/* import __COLOCATED_TEMPLATE__ from './select-kit-none-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const SelectKitNoneRow = dt7948.c(class SelectKitNoneRow extends SelectKitRowComponent {}, [classNames("none")]);
export default SelectKitNoneRow;